import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ProductCarousel from './components/ProductCarousel';
import AboutSection from './components/AboutSection';
import TrustSection from './components/TrustSection';
import ArticlePreview from './components/ArticlePreview';
import { productCategories } from '@/mocks/products';
import { useSeo } from '@/seo/useSeo';
import { injectWebPageSchema } from '@/seo/schema';

export default function Home() {
  const { t } = useTranslation();

  useSeo({
    title: 'AllChinaBuy Spreadsheet 2026 — Best Finds, Links & Buying Guide | allchinabuyspread.de',
    description:
      'Explore the latest AllChinaBuy spreadsheet resources, product finds, buying guides, QC information, shipping guides and useful product links — all organized in one place. Your trusted AllChinaBuy resource hub.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy Finds, AllChinaBuy Review, AllChinaBuy Shipping, AllChinaBuy Coupon, AllChinaBuy Guide',
    path: '/',
    type: 'website',
  });

  useEffect(() => {
    injectWebPageSchema(
      '/',
      'AllChinaBuy Spreadsheet 2026 — Best Finds, Links & Buying Guide',
      'Explore the latest AllChinaBuy spreadsheet resources, product finds, buying guides, QC information, shipping guides and useful product links — all organized in one place.'
    );
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ProductCarousel categories={productCategories} />
        <AboutSection />
        <TrustSection />
        <ArticlePreview />
        
        {/* Disclaimer */}
        <section className="w-full py-8 md:py-10 bg-white border-t border-background-200/40">
          <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto text-center">
            <p className="text-xs text-foreground-500 leading-relaxed">
              {t('disclaimer')}
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}